import { ClassificationEmployeur } from './classification-employeur';

export class Employeur
{
    id:number;
    active:boolean;
    label:String;
    description:String;
    echeance:number;
    classificationEmployeur:ClassificationEmployeur;
}